import { render, staticRenderFns } from "./TermsService.vue?vue&type=template&id=7eafb0a1&scoped=true"
import script from "./TermsService.vue?vue&type=script&lang=js"
export * from "./TermsService.vue?vue&type=script&lang=js"
import style0 from "./TermsService.vue?vue&type=style&index=0&id=7eafb0a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eafb0a1",
  null
  
)

export default component.exports